import { Box, Fade } from "@mui/material";
import Loading from "./Loading/Loading";

const BoxLoading = ({
  loading = false,
  children,
  sx = [],
  light = false,
}: {
  loading: boolean;
  children: React.ReactNode;
  sx?: object;
  light?: boolean;
}) => (
  <Box
    sx={{
      ...(loading
        ? {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: light ? "#fff" : "rgba(0, 0, 0, 0.3)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }
        : {}),
    }}
  >
    <Fade in={!loading} timeout={500}>
      <Box
        sx={{
          opacity: loading ? 0 : 1,
          transition: "opacity 0.5s ease-in-out",
          ...sx,
        }}
      >
        {!loading ? children : ""}
      </Box>
    </Fade>

    <Fade in={loading} timeout={500} unmountOnExit>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: light ? "#fff" : "rgba(0, 0, 0, 0.3)",
          zIndex: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loading />
      </Box>
    </Fade>
  </Box>
);

export default BoxLoading;
